import styled from 'styled-components';

import { LabelL } from '@sorare/core/src/atoms/typography';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

export const SelectHeader = styled(LabelL).attrs({ bold: true })`
  padding: var(--unit) var(--double-unit);
  @media ${laptopAndAbove} {
    display: none;
  }
`;
